// @ts-nocheck
export default class FatalPasswordResetError extends Error {}
